module.exports = __webpack_public_path__ + "static/media/tab.d9e309d8.png";